/**
 * ActionButon component, representing a big button.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2026
 */
import './ActionButton.css'

const ActionButtonClass = 'action-button'

export interface ActionButtonProps {
  className?: string
  id?: string
  onClick?: () => void
  label?: string
  disabled?: boolean
  children?: any
}

const ActionButton = (props: ActionButtonProps) => {
  return (
    <button
      type="button"
      onClick={props.onClick}
      disabled={props.disabled}
      id={props.id}
      className={
        props.className
          ? `${ActionButtonClass} ${props.className}`
          : ActionButtonClass
      }
    >
      {props.children}
    </button>
  )
}

export default ActionButton
